import React, { Component } from 'react';
import Switch from 'react-toggle-switch';
import { kanaDictionary } from '../../data/kanaDictionary';
import './ChooseCharacters.scss';
import CharacterGroup from './CharacterGroup';
import { kanjiDictionary } from '../../data/kanjiDictionary';

class ChooseCharacters extends Component {
  state = {
    errMsg : '',
    selectedGroups: this.props.selectedGroups,
    showAlternatives: [],
    showSimilar: [],
    showKanjiLessons: [],
    kanjiShownRows: {},
    startIsVisible: true
  }

  getKanjiLessonSubIds(groupName) {
    const group = kanjiDictionary['kanji'][groupName];
    const chars = (group && group.characters) ? group.characters : {};
    const ids = [];

    if (this.getKanjiCharsString(chars, 'kun')) ids.push(groupName + '_kun');
    if (this.getKanjiCharsString(chars, 'on')) ids.push(groupName + '_on');

    return ids;
  }

  getSelectedInKanjiLesson(groupName) {
    const ids = this.getKanjiLessonSubIds(groupName);
    let count = 0;
    ids.forEach(id => { if (this.isSelected(id)) count++; });
    return count;
  }

  getAmountInKanjiLesson(groupName) {
    return this.getKanjiLessonSubIds(groupName).length;
  }

  toggleKanjiLessonSelectAll(groupName) {
    const ids = this.getKanjiLessonSubIds(groupName);
    if (ids.length === 0) return;

    const selected = this.getSelectedInKanjiLesson(groupName);

    // if all selected -> deselect all, else select all
    if (selected >= ids.length) {
      let next = this.state.selectedGroups.slice();
      ids.forEach(id => {
        const idx = next.indexOf(id);
        if (idx >= 0) next.splice(idx, 1);
      });
      this.setState({ errMsg: '', selectedGroups: next });
    } else {
      let next = this.state.selectedGroups.slice();
      ids.forEach(id => {
        if (next.indexOf(id) < 0) next.push(id);
      });
      this.setState({ errMsg: '', selectedGroups: next });
    }
  }

  setKanjiShownRow(rowId, str) {
    const next = Object.assign({}, this.state.kanjiShownRows);
    next[rowId] = str;
    this.setState({ kanjiShownRows: next });
  }

  getKanjiCharsString(characters, whichReading) {
    let str = '';
    Object.keys(characters).forEach(kanjiChar => {
      const entry = characters[kanjiChar] || {};
      const readings = entry[whichReading];
      if (Array.isArray(readings) && readings.length > 0) {
        str += kanjiChar + ' · ';
      }
    });
    return str.length ? str.slice(0, -2) : '';
  }

  getKanjiReadingsString(characters, whichReading) {
    // Flatten readings from all kanji in this lesson/category.
    // De-dupe while preserving order.
    const seen = {};
    let out = [];

    Object.keys(characters).forEach(kanjiChar => {
      const entry = characters[kanjiChar] || {};
      const readings = entry[whichReading];
      if (Array.isArray(readings) && readings.length > 0) {
        readings.forEach(r => {
          if (!seen[r]) {
            seen[r] = true;
            out.push(r);
          }
        });
      }
    });

    return out.length ? out.join(' · ') : '';
  }

  renderKanjiReadingRow(groupName, whichReading, characters) {
    const rowId = groupName + '_' + whichReading;

    const kanjiStr = this.getKanjiCharsString(characters, whichReading);
    if (!kanjiStr) return null; // skip if no reading exists in this category

    const readingStr = this.getKanjiReadingsString(characters, whichReading);

    const shown = this.state.kanjiShownRows[rowId] || kanjiStr;

    return (
      <div
        key={rowId}
        className="choose-row alt-row"
        onClick={() => {
          this.toggleSelect(rowId);
          this.setKanjiShownRow(rowId, kanjiStr);
        }}
        onMouseDown={() => {
          if (readingStr) this.setKanjiShownRow(rowId, readingStr);
        }}
        onMouseOut={() => this.setKanjiShownRow(rowId, kanjiStr)}
        onTouchStart={() => {
          if (readingStr) this.setKanjiShownRow(rowId, readingStr);
        }}
        onTouchEnd={() => this.setKanjiShownRow(rowId, kanjiStr)}
      >
      <span className={this.isSelected(rowId) ?
        'glyphicon glyphicon-small glyphicon-check' :
        'glyphicon glyphicon-small glyphicon-unchecked'}></span>

        <b> {whichReading}:</b>&nbsp;{shown}
      </div>
    );
  }
  toggleKanjiLesson = (lessonGroupName) => {
    let show = this.state.showKanjiLessons.slice();
    const idx = show.indexOf(lessonGroupName);
    if (idx >= 0) show.splice(idx, 1);
    else show.push(lessonGroupName);
    this.setState({ showKanjiLessons: show });
  }
  kanjiLessonToggleRow(groupName, lessonNumber, expanded) {
    let checkBtn = "glyphicon glyphicon-small glyphicon-";
    let status;

    const selected = this.getSelectedInKanjiLesson(groupName);
    const total = this.getAmountInKanjiLesson(groupName);

    if (total > 0 && selected >= total) status = 'check';
    else if (selected > 0) status = 'check half';
    else status = 'unchecked';

    checkBtn += status;

    return (
      <div
        key={'kanji_lesson_' + groupName}
        onClick={() => this.toggleKanjiLesson(groupName)}
        className="choose-row"
      >
      <span
        className={checkBtn}
        onClick={(e) => {
          // Lesson checkbox toggles all subgroups
          this.toggleKanjiLessonSelectAll(groupName);
          e.stopPropagation();
        }}
      ></span>

        {expanded ? <span className="toggle-caret">&#9650;</span>
          : <span className="toggle-caret">&#9660;</span>}

        {'Lesson ' + lessonNumber}
      </div>
    );
  }


  showKanjiLessonRows() {
    const kanji = kanjiDictionary['kanji'];
    let rows = [];

    Object.keys(kanji).forEach((groupName) => {
      const group = kanji[groupName];
      const lessonNumber = parseInt(groupName.replace(/\D/g, ''));

      const expanded = this.state.showKanjiLessons.indexOf(groupName) >= 0;

      rows.push(this.kanjiLessonToggleRow(groupName, lessonNumber, expanded));

      if (expanded) {
        const chars = (group && group.characters) ? group.characters : {};

        const kunRow = this.renderKanjiReadingRow(groupName, 'kun', chars);
        if (kunRow) rows.push(kunRow);

        const onRow = this.renderKanjiReadingRow(groupName, 'on', chars);
        if (onRow) rows.push(onRow);
      }

    });

    return rows;
  }


  componentDidMount() {
    this.testIsStartVisible();
    window.addEventListener('resize', this.testIsStartVisible);
    window.addEventListener('scroll', this.testIsStartVisible);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.testIsStartVisible);
    window.removeEventListener('scroll', this.testIsStartVisible);
  }

  componentDidUpdate(prevProps, prevState) {
    this.testIsStartVisible();
  }

  testIsStartVisible = () => {
    if(this.startRef) {
      const rect = this.startRef.getBoundingClientRect();
      if(rect.y > window.innerHeight && this.state.startIsVisible)
        this.setState({ startIsVisible: false });
      else if(rect.y <= window.innerHeight && !this.state.startIsVisible)
        this.setState({ startIsVisible: true });
    }
  }

  scrollToStart() {
    if(this.startRef) {
      const rect = this.startRef.getBoundingClientRect();
      const absTop = rect.top + window.pageYOffset;
      const scrollPos = absTop - window.innerHeight + 50;
      window.scrollTo(0, scrollPos > 0 ? scrollPos : 0);
    }
  }

  getIndex(groupName) {
    return this.state.selectedGroups.indexOf(groupName);
  }

  isSelected(groupName) {
    return this.getIndex(groupName) > -1;
  }

  removeSelect(groupName) {
    if(this.getIndex(groupName)<0)
      return;
    let newSelectedGroups = this.state.selectedGroups.slice();
    newSelectedGroups.splice(this.getIndex(groupName), 1);
    this.setState({selectedGroups: newSelectedGroups});
  }

  addSelect(groupName) {
    this.setState({errMsg: '', selectedGroups: this.state.selectedGroups.concat(groupName)});
  }

  toggleSelect = groupName => {
    if(this.getIndex(groupName) > -1)
      this.removeSelect(groupName);
    else
      this.addSelect(groupName);
  }

  selectAllKanji(kun = true, on = true) {
    let newSelectedGroups = this.state.selectedGroups.slice();

    const kanji= kanjiDictionary['kanji'];
    Object.keys(kanji).forEach(groupName => {
      const chars = kanji[groupName] && kanji[groupName].characters ? kanji[groupName].characters : {};

      if (kun && this.getKanjiCharsString(chars, 'kun')) {
        const id = groupName + '_kun';
        if (!this.isSelected(id)) newSelectedGroups.push(id);
      }

      if (on && this.getKanjiCharsString(chars, 'on')) {
        const id = groupName + '_on';
        if (!this.isSelected(id)) newSelectedGroups.push(id);
      }
    });

    this.setState({ errMsg: '', selectedGroups: newSelectedGroups });
  }

  selectAllKana(whichKana, altOnly=false, similarOnly=false) {
    let newSelectedGroups = this.state.selectedGroups.slice();

    // existing kana logic unchanged
    const thisKana = kanaDictionary[whichKana];
    Object.keys(thisKana).forEach(groupName => {
      if(!this.isSelected(groupName) && (
        (altOnly && groupName.endsWith('_a')) ||
        (similarOnly && groupName.endsWith('_s')) ||
        (!altOnly && !similarOnly)
      ))
        newSelectedGroups.push(groupName);
    });
    this.setState({errMsg: '', selectedGroups: newSelectedGroups});
  }

  selectNoneKanji(kun = true, on = true) {
    const kanji= kanjiDictionary['kanji'];
    const removable = {};

    Object.keys(kanji).forEach(groupName => {
      const chars = kanji[groupName] && kanji[groupName].characters ? kanji[groupName].characters : {};

      if (kun && this.getKanjiCharsString(chars, 'kun')) removable[groupName + '_kun'] = true;
      if (on && this.getKanjiCharsString(chars, 'on')) removable[groupName + '_on'] = true;
    });

    const newSelectedGroups = this.state.selectedGroups.filter(id => !removable[id]);
    this.setState({ selectedGroups: newSelectedGroups });
  }

  selectNoneKana(whichKana, altOnly=false, similarOnly=false) {
    let newSelectedGroups = [];
    this.state.selectedGroups.forEach(groupName => {
      let mustBeRemoved = false;
      Object.keys(kanaDictionary[whichKana]).forEach(removableGroupName => {
        if(removableGroupName === groupName && (
          (altOnly && groupName.endsWith('_a')) ||
          (similarOnly && groupName.endsWith('_s')) ||
          (!altOnly && !similarOnly)
        ))
          mustBeRemoved = true;
      });
      if(!mustBeRemoved)
        newSelectedGroups.push(groupName);
    });
    this.setState({selectedGroups: newSelectedGroups});
  }

  toggleAlternative(whichKana, postfix) {
    let show = postfix === '_a' ? this.state.showAlternatives : this.state.showSimilar;
    const idx = show.indexOf(whichKana);
    if(idx >= 0)
      show.splice(idx, 1);
    else
      show.push(whichKana)
    if(postfix === '_a')
      this.setState({showAlternatives: show});
    if(postfix === '_s')
      this.setState({showSimilar: show});
  }

  getSelectedAlternatives(whichKana, postfix) {
    return this.state.selectedGroups.filter(groupName => {
      return groupName.startsWith(whichKana === 'hiragana' ? 'h_' : 'k_') &&
        groupName.endsWith(postfix);
    }).length;
  }

  getAmountOfAlternatives(whichKana, postfix) {
    return Object.keys(kanaDictionary[whichKana]).filter(groupName => {
      return groupName.endsWith(postfix);
    }).length;
  }

  alternativeToggleRow(whichKana, postfix, show) {
    let checkBtn = "glyphicon glyphicon-small glyphicon-"
    let status;
    if(this.getSelectedAlternatives(whichKana, postfix) >= this.getAmountOfAlternatives(whichKana, postfix))
      status = 'check';
    else if(this.getSelectedAlternatives(whichKana, postfix) > 0)
      status = 'check half';
    else
      status = 'unchecked'
    checkBtn += status

    return <div
      key={'alt_toggle_' + whichKana + postfix}
      onClick={() => this.toggleAlternative(whichKana, postfix)}
      className="choose-row"
    >
      <span
        className={checkBtn}
        onClick={ e => {
          if(status === 'check')
            this.selectNoneKana(whichKana, postfix === '_a', postfix === '_s');
          else if(status === 'check half' || status === 'unchecked')
            this.selectAllKana(whichKana, postfix === '_a', postfix === '_s');
          e.stopPropagation();
        }}
      ></span>
      {
        show ? <span className="toggle-caret">&#9650;</span>
          : <span className="toggle-caret">&#9660;</span>
      }
      {
        postfix === '_a' ? 'Alternative characters (ga · ba · kya..)' :
          'Look-alike characters'
      }
    </div>
  }

  showGroupRows(whichKana, showAlternatives, showSimilar = false) {
    if (whichKana === 'kanji') {
      return this.showKanjiLessonRows();
    }

    const thisKana = kanaDictionary[whichKana];
    let rows = [];
    let invertRender = whichKana === 'kanji';

    Object.keys(thisKana).forEach((groupName, idx) => {
      if(groupName === "h_group11_a" || groupName === "k_group13_a")
        rows.push(this.alternativeToggleRow(whichKana, "_a", showAlternatives));
      if(groupName === "k_group11_s")
        rows.push(this.alternativeToggleRow(whichKana, "_s", showSimilar));

      if((!groupName.endsWith("a") || showAlternatives) &&
        (!groupName.endsWith("s") || showSimilar)) {
        rows.push(<CharacterGroup
          key={idx}
          groupName={groupName}
          selected={this.isSelected(groupName)}
          characters={thisKana[groupName].characters}
          handleToggleSelect={this.toggleSelect}
          invertRender={invertRender}
        />);
      }
    });

    return rows;
  }

  startGame() {
    if(this.state.selectedGroups.length < 1) {
      this.setState({ errMsg: 'Choose at least one group!'});
      return;
    }
    this.props.handleStartGame(this.state.selectedGroups);
  }

  render() {
    return (
      <div className="choose-characters">
        <div className="row">
          <div className="col-xs-12">
            <div className="panel panel-default">
              <div className="panel-body welcome">
                <h4>Welcome to Kana Pro!</h4>
                <p>Please choose the groups of characters that you'd like to be studying.</p>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <div className="panel panel-default">
              <div className="panel-heading">Kanji · 漢字
                <div className="col-sm-6 col-xs-12 pull-right">
                  <span className="pull-right lock">Show Meaning &nbsp;
                    <Switch onClick={() => this.props.showMeaning(!this.props.meaningsEnabled)} on={this.props.meaningsEnabled}/></span>
                </div>
              </div>
              <div className="panel-body selection-areas">
                {this.showGroupRows('kanji', this.state.showAlternatives.indexOf('kanji') >= 0)}
              </div>
              <div className="panel-footer text-center">
                <span className="button-group">
                  <a href="javascript:"  onClick={() => this.selectAllKanji()}>All</a> &nbsp;&middot;&nbsp; <a
                  href="javascript:"  onClick={() => this.selectNoneKanji()}>None</a>
                </span>

                 <span className="button-group">
                  <a href="javascript:"  onClick={() => this.selectAllKanji(true, false)}>All kun-yomi</a> &nbsp;&middot;&nbsp; <a
                  href="javascript:"  onClick={() => this.selectAllKanji(false, true)}>All on-yomi</a>
                </span>

                 <span className="button-group">
                  <a href="javascript:"  onClick={() => this.selectNoneKanji(true, false)}>No kun-yomi</a> &nbsp;&middot;&nbsp; <a
                  href="javascript:"  onClick={() => this.selectNoneKanji(false, true)}>No on-yomi</a>
                </span>
              </div>

            </div>
          </div>
          <div className="col-sm-6">
            <div className="panel panel-default">
              <div className="panel-heading">Hiragana · ひらがな</div>
              <div className="panel-body selection-areas">
                {this.showGroupRows('hiragana', this.state.showAlternatives.indexOf('hiragana') >= 0)}
              </div>
              <div className="panel-footer text-center">
                <a href="javascript:" onClick={() => this.selectAllKana('hiragana')}>All</a> &nbsp;&middot;&nbsp; <a
                href="javascript:"
                onClick={() => this.selectNoneKana('hiragana')}>None</a>
                &nbsp;&middot;&nbsp; <a href="javascript:" onClick={() => this.selectAllKana('hiragana', true)}>All
                alternative</a>
                &nbsp;&middot;&nbsp; <a href="javascript:" onClick={() => this.selectNoneKana('hiragana', true)}>No
                alternative</a>
              </div>
            </div>
          </div>
          <div className="col-sm-6">
            <div className="panel panel-default">
              <div className="panel-heading">Katakana · カタカナ</div>
              <div className="panel-body selection-areas">
                {this.showGroupRows('katakana', this.state.showAlternatives.indexOf('katakana') >= 0, this.state.showSimilar.indexOf('katakana') >= 0)}
              </div>
              <div className="panel-footer text-center">
                <a href="javascript:" onClick={() => this.selectAllKana('katakana')}>All</a> &nbsp;&middot;&nbsp; <a
                href="javascript:"
                onClick={() => this.selectNoneKana('katakana')}>None
              </a>
                &nbsp;&middot;&nbsp; <a href="javascript:" onClick={() => this.selectAllKana('katakana', true)}>All
                alternative</a>
                &nbsp;&middot;&nbsp; <a href="javascript:" onClick={() => this.selectNoneKana('katakana', true)}>No
                alternative</a>
              </div>
            </div>
          </div>
          <div className="col-sm-3 col-xs-12 pull-right">
            <span className="pull-right lock">Lock to stage &nbsp;
              {
                this.props.isLocked &&
                <input className="stage-choice" type="number" min="1" max="4" maxLength="1" size="1"
                       onChange={(e) => this.props.lockStage(e.target.value, true)}
                       value={this.props.stage}
                />
              }
              <Switch onClick={() => this.props.lockStage(1)} on={this.props.isLocked}/></span>
          </div>
          <div className="col-sm-offset-3 col-sm-6 col-xs-12 text-center">
            {
              this.state.errMsg !== '' &&
              <div className="error-message">{this.state.errMsg}</div>
            }
            <button ref={c => this.startRef = c} className="btn btn-danger startgame-button"
                    onClick={() => this.startGame()}>Start the Quiz!
            </button>
          </div>
          <div className="down-arrow"
               style={{display: this.state.startIsVisible ? 'none' : 'block'}}
               onClick={(e) => this.scrollToStart(e)}
          >
            Start
          </div>
        </div>
      </div>
    );
  }
}

export default ChooseCharacters;
